import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef,
	HostListener
} 
from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//DataSource
import { SoDoKhoDataSource } from '../so-do-kho-datasource/so-do-kho.datasource';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SoDoKhoService } from '../so-do-kho-service/so-do-kho.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { KhuVucKho, KhoTinhTrangKho, KhoVTKConfig } from '../so-do-kho-model/so-do-kho.model';
import { KhoModel } from '../../../kho/kho-model/kho.model';
//Component
import { XemHangLuuKhoComponent } from '../xem-hang-luu-kho/xem-hang-luu-kho.component';

@Component({
	selector: 'm-so-do-kho-view-dialog-ver2',
	templateUrl: './so-do-kho-view-dialog-ver2.component.html',
	styleUrls: ['../so-do-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class SoDoKhoViewVer2Component implements OnInit{

    /*Config Form */
    CONFIG: CommonConFig;

    // Table fields
    dataSource: SoDoKhoDataSource;

    displayedColumns = [];
    availableColumns = [];

    // Selection
    selectedColumns = new SelectionModel<any>(true, this.availableColumns);

    loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    rongSaver:any[] = [];
    daiSaver:any[] = [];
    caoSaver:any[] = [];
    kvkSaver2d: KhuVucKho[][] = [[]];
    SelectedItem: KhuVucKho[] = [];
    SelectedItemVer2: KhuVucKho;
    ListViTriKho: string[];
	listTTHangKho: KhoTinhTrangKho[] = [];

    khoModel: KhoModel;
    flagSubmit: boolean = true;
    flagLeftClickObject: KhuVucKho[] = [];
    KhuVucSaver:any[] = [];
    KhuVucHeThongSaver: any[] = [];
    type: any;
    currentSelect: string;

    /* Extend field:  */
	title: string = '';					// Tiêu đề dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
    listDataVTKConfig: KhoVTKConfig[] = [];
    listVTKConfigDM: any[] = [];
    /* ------------------------------------------------------------------ */

    constructor(
		public dialogRef: MatDialogRef<SoDoKhoViewVer2Component>,
		@Inject(MAT_DIALOG_DATA) public data: any,
        private soDoKhoService: SoDoKhoService,
        private dungChungService: DungChungService,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
    ) { 
		this.dialogRef.disableClose = true;
    }

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
        /*Load cấu hình config form */
        this.CONFIG = new CommonConFig();

        /*Get data from list when open dialog */
        this.khoModel = this.data.data;
        this.type = this.data.type;
        this.currentSelect = this.data.currentSelected;

        /*Load title of dialog */
        this.title = this.getTitle();
        this.ListVTKConfigDM();
        this.getTTHangLuuKho(this.khoModel.Id_Kho, this.khoModel.Cot, this.khoModel.Hang)
        this.getDS_ViTriKho_Empty(this.khoModel.Id_Kho);
        this.resetKhuHangSaver();

        this.KhuVucHeThongSaver.push(
			{
				name: 'Vị trí trống',
				color: KhuVucKho.defaultColor.CLEAR
			},
			{
				name: 'Đường đi',
				color: KhuVucKho.defaultColor.ROAD
			},
			{
				name: 'Vị trí không được lưu kho',
				color: KhuVucKho.defaultColor.NOT_SAVE
			},

        );
        /*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back(0);
			}
			this.changeDetectView();
        });
    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    getTitle(): string {
		return 'CHỌN VỊ TRÍ LƯU KHO';
    }
    /* -----------------------------------------------------------------------*/


    /*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
    showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
    }
    applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
    }
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
    changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
    back(type: number){
        if(type == 0)
            this.dialogRef.close()
        else{
            if(this.type == 0 && this.SelectedItem.length > 1){
                this.layoutUtilsService.showErorr('Chỉ được chọn 1 vị trí. Vui lòng chọn lại!')
                return;
            }
            let result = [];
            this.SelectedItem.forEach(element =>{
                let position = this.pad(element.TuHang,3) + '.' + this.pad(element.TuCot,3) + '.' + this.pad(element.currentSelectTang,2)
                result.push(position)
            })
            this.dialogRef.close({ 
                vitrikho : result
            });
        }
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if( event.keyCode == 18 && this.SelectedItem.length > 0) {
            let first = this.flagLeftClickObject[0];
            let second = this.SelectedItem[this.SelectedItem.length - 1];

            let firstRow = -1;
            let firstCol = -1;

            let secondRow = -1;
            let secondCol = -1;
            
            if(first != null && first != undefined && second != null && second != undefined){
                for(let i = 0; i < this.kvkSaver2d.length; i++){
                    for(let j = 0; j < this.kvkSaver2d[i].length; j++){
                        if(this.kvkSaver2d[i][j] === first){
                            firstRow = i;
                            firstCol = j;
                        }
                        if(this.kvkSaver2d[i][j] === second){
                            secondRow = i;
                            secondCol = j;
                        }
                    }
                }
                if(firstRow > secondRow){
                    let tmp = firstRow;
                    firstRow = secondRow;
                    secondRow = tmp;
                }
                if(firstCol > secondCol){
                    let tmp = firstCol;
                    firstCol = secondCol;
                    secondCol = tmp;
                }
                for(let i = firstRow; i <= secondRow; i++){
                    for(let j = firstCol; j <= secondCol; j++){
                        if(!this.kvkSaver2d[i][j].isSelect && this.kvkSaver2d[i][j].TuHang > 0 && this.kvkSaver2d[i][j].TuCot > 0){
                            this.kvkSaver2d[i][j].isSelect = true;
                            this.SelectedItem.push(this.kvkSaver2d[i][j]);
                        }
                    }
                }
                this.changeDetectView();
            }
        }
	}
    /* -----------------------------------------------------------------------*/

    
    /*----------------------- Hàm xử lý sự kiện click ------------------------*/
    clickEvent(row: number, column: number){
        if(this.kvkSaver2d[row][column].TuHang > 0 && this.kvkSaver2d[row][column].TuCot > 0){

            this.checkStoreClickObject();
            this.flagLeftClickObject.push(this.kvkSaver2d[row][column]);

            this.kvkSaver2d[row][column].isSelect = !this.kvkSaver2d[row][column].isSelect
            if(this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                this.SelectedItem.push(this.kvkSaver2d[row][column]);
            }
            else if(!this.kvkSaver2d[row][column].isSelect && this.kvkSaver2d[row][column].TuHang >= 0 && this.kvkSaver2d[row][column].TuCot >= 0){
                for(let i = 0; i < this.SelectedItem.length; i++){
                    if(this.SelectedItem[i] === this.kvkSaver2d[row][column]){
                        this.SelectedItem.splice(i,1);
                        break;
                    }
                }
            }
        }   
    }
    checkStoreClickObject(){
        if(this.flagLeftClickObject.length == 2)
            this.flagLeftClickObject.splice(0,1);
    }
    /* -----------------------------------------------------------------------*/


    /*------------------------- Hàm xử lý dữ liệu ----------------------------*/
    pad(str: any, max: any) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
    }
    loadSoDoKho(item: KhoModel) {
		this.soDoKhoService.loadDataKV(item.Id_Kho).subscribe(res => {
			if (res && res.status === 1) {

				this.availableColumns = [];
				this.caoSaver = [];
				this.daiSaver = [];
				this.rongSaver = [];

				for (let i = 1; i <= item.Tang; i++)
					this.caoSaver.push(i);
				this.caoSaver = this.caoSaver.sort((a, b) => a - b);

				let _listDataRes = res.data

				_listDataRes.forEach(element => {
					let _indexCot = this.rongSaver.findIndex(x => x == element.DenHang)
					if (_indexCot == -1) {
						this.rongSaver.push(element.DenHang)
					}

					let _indexHang = this.daiSaver.findIndex(x => x == element.DenCot)
					if (_indexHang == -1) {
						this.daiSaver.push(element.DenCot)
					}

					let _indexKhuHang = this.KhuVucSaver.findIndex(x => x.color == element.MaMau)
					if (_indexKhuHang == -1) {
						let _indexKhuHangHeThong = this.KhuVucHeThongSaver.findIndex(x => x.color == element.MaMau)
						if (_indexKhuHangHeThong == -1) {
							this.KhuVucSaver.push({
								name: element.MaKhuVuc,
								color: element.MaMau
							});
						}
					}
				});
				this.daiSaver = this.daiSaver.sort((a, b) => a - b);
				this.rongSaver = this.rongSaver.sort((a, b) => a - b);

                for (let i = 1; i <= this.rongSaver.length; i++) {
					this.availableColumns.push({
						stt: i,
						name: '' + i,
						isShow: true
					})
				}

				for (let i = 0; i < this.daiSaver.length; i++) {
					this.daiSaver[i] += 1;
					// this.availableColumns.push({
					// 	stt: this.daiSaver[i],
					// 	name: '' + this.daiSaver[i],
					// 	isShow: true
					// })
				}
                this.daiSaver.reverse();

				this.kvkSaver2d = [];
				for (let i = 0; i < this.rongSaver.length; i++) {
					this.kvkSaver2d[i] = [];

					let _arrayRow = _listDataRes.filter(x => x.DenHang == this.rongSaver[i])
					_arrayRow.sort(function (a, b) { return a.DenCot - b.DenCot });

					for (let j = 0; j < _arrayRow.length; j++) {
						let objectTmp = new KhuVucKho();
						objectTmp.copy(_arrayRow[j]);
                        this.kvkSaver2d[i][j] = objectTmp;
                        this.kvkSaver2d[i][j].viTriLuuHang = this.fillStartViTri(i,j);
                        this.kvkSaver2d[i][j].currentSelectTang = 1;
					}
					this.rongSaver[i] += 1;
				}

				this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);

				this.showColumnsInTable();
                this.applySelectedColumns();

                this.soDoKhoService.loadDataConfigVTK(item.Id_Kho).subscribe(res => {
					if (res && res.status === 1){
						if(res.data && res.data.length > 0){
							this.listDataVTKConfig = [];
							res.data.forEach(el => {
								let configVTK = new KhoVTKConfig();
								configVTK.copy(el);
								this.listDataVTKConfig.push(configVTK);
							});
						}
					}
					this.changeDetectView();
				});
                
                if(this.currentSelect != ""){
                    let indexHang = +this.currentSelect.split(".")[0]
                    let indexCot = +this.currentSelect.split(".")[1]
                    let indexTang = +this.currentSelect.split(".")[2]
                   
                    let isFind = false;
                    for(let i = 0; i < this.kvkSaver2d.length; i++){
                        for(let j = 0; j < this.kvkSaver2d[0].length; j++){
                            if(this.kvkSaver2d[i][j].TuHang == indexHang && this.kvkSaver2d[i][j].TuCot == indexCot){
                                this.kvkSaver2d[i][j].currentSelectTang = indexTang;
                                this.clickEvent(i,j);
                                isFind = true;
                                break;
                            }
                        }
                        if(isFind) break;
                    }
                }
				this.changeDetectView();
			}
			else {
				this.layoutUtilsService.showActionNotification('Lỗi load dữ liệu sơ đồ kho', MessageType.Delete);
			}
		});
	}
    resetThietLap(){
        this.rongSaver = [];
        this.daiSaver = [];
        this.caoSaver = [];
        this.resetKhuHangSaver();
        this.changeDetectView();
    }
    resetKhuHangSaver(){
        this.KhuVucSaver = [];
    }
    checkDuongDi(item: KhuVucKho){
        return (item.TuHang < 0 && item.TuCot < 0)
    }
    getDS_ViTriKho_Empty(IdKho: number){
		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.dungChungService.getDSVTKEmpty(IdKho).subscribe(res => {
			if(res && res.status == 1){
				listVTK_Full = res.data.listVTK;
				hKhoMax = res.data.hKho;
				cKhoMax = res.data.cKho;
				tKhoMax = res.data.tKho;
				for(let t = tKho; t <= tKhoMax; t++){
					for(let c = cKho; c <= cKhoMax; c++){
						for(let h = hKho; h <= hKhoMax; h++){
							let value = this.pad(h,3)+"."+this.pad(c,3)+"."+this.pad(t,2);
							if(listVTK_Full.findIndex(x => x == value) == -1){
								listVTK_Empty.push(value);
							}
						}
					}
                }
                this.ListViTriKho = listVTK_Empty;
            }
            this.loadSoDoKho(this.khoModel)
		});
    }
    fillStartViTri(row: number, column: number){
        let formatPosition = this.pad(this.kvkSaver2d[row][column].TuHang,3) + '.' + this.pad(this.kvkSaver2d[row][column].TuCot,3) 
        let filterListViTri = this.ListViTriKho.filter(x => x.indexOf(formatPosition) > -1)
        
        if(filterListViTri.length == this.kvkSaver2d[row][column].SoTang){
            return 2;
        }
        else if(filterListViTri.length > 0 && filterListViTri.length < this.kvkSaver2d[row][column].SoTang){
            return 1;
        }
        else if(filterListViTri.length == 0){
            return 0;
        }
        return -1;
    }
    xemHangLuuKho(item: KhuVucKho){
        const dialogRef = this.dialog.open(XemHangLuuKhoComponent, {
            data: {
               khuvuc: item,
               kho: this.khoModel
            },
            maxHeight: '90vh',
            width: '90vw'
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res == undefined || res == null) {
                return;
            }
            else{
                if(res.dataAdd != null && res.dataAdd.length > 0){
                  
                }
            }
        });
    }
    async getTTHangLuuKho(IdKho:number, cot: number, hang:number){
		let res = await this.soDoKhoService.getTTHangKho(IdKho,cot,hang).toPromise();
		
		if(res && res.status === 1){
			this.listTTHangKho = res.data;
			this.changeDetectView();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
    checkTypeStarPosition(position: string){
		
		let _item = this.listTTHangKho.find( x => x.MaSo == position)
		if(_item != null){
            if(_item.isMax){
                return 4;
            }
			else if(_item.TongSoHang == 0){
				return 1;
			}
			else if(_item.TongSoHang > 0 && _item.HangChuaXacNhan > 0){
				return 2;
			}
			else if(_item.TongSoHang > 0 &&  _item.HangChuaXacNhan == 0){
				return 3;
			}
		}
		return -1;
	}
    getKLMax(VTK: string){
		if(VTK){
			let configObj = this.listDataVTKConfig.find(x => x.VTK == VTK);
			if(configObj){
				let dmConfig = this.listVTKConfigDM.find(el => el.Id == configObj.IdDMVTKConfig);
				if(dmConfig){
					return dmConfig.KL +'Kg';
				}
			}
		}
		return '';
	}
    ListVTKConfigDM() {
		this.dungChungService.ListVTKConfigDM().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listVTKConfigDM = res.data;
				this.changeDetectView();
			};
		});
	}
    /* -----------------------------------------------------------------------*/

}